const API_BASE = "https://api.mariamlyluxe.com/public";

// Cache for contact info to avoid multiple API calls
let contactInfoCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const fetchContactInfo = async () => {
  // Return cached data if it's still valid
  if (contactInfoCache && cacheTimestamp && (Date.now() - cacheTimestamp) < CACHE_DURATION) {
    return contactInfoCache;
  }

  try {
    const response = await fetch(`${API_BASE}/api/contact-info`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.success && data.contact) {
      // Cache the result
      contactInfoCache = data.contact;
      cacheTimestamp = Date.now();
      return data.contact;
    } else {
      throw new Error('Invalid response format');
    }
  } catch (error) {
    console.error('Error fetching contact info:', error);
    
    // Return fallback data if API fails
    return {
      phone: "+961-70 457 945",
      email: "info@mariamlyluxe.com",
      location: "Tripoli"
    };
  }
};

// Helper function to format phone number for WhatsApp
export const formatPhoneForWhatsApp = (phone) => {
  if (!phone) return "";
  // Remove all non-digit characters and add country code if needed
  const digits = phone.replace(/\D/g, "");
  return digits.startsWith("961") ? digits : `961${digits}`;
};
